import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export interface ConfirmDiscardDialogProps {
    open: boolean;
    title: string;
    message: string;
    discardLabel: string;
    keepEditingLabel: string;
    onDiscard: () => void;
    onKeepEditing: () => void;
    isLoading?: boolean;
}

/**
 * Modal prompt shown when a user attempts to leave a section/page with
 * unsaved edits. Reusable across section-level cancel and route navigation.
 */
export const ConfirmDiscardDialog = ({
    open,
    title,
    message,
    discardLabel,
    keepEditingLabel,
    onDiscard,
    onKeepEditing,
    isLoading,
}: ConfirmDiscardDialogProps) => (
    <Dialog
        open={open}
        onClose={isLoading ? undefined : onKeepEditing}
        automation-id="confirm-discard-dialog"
        maxWidth="xs"
        fullWidth
    >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
            <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button
                onClick={onKeepEditing}
                disabled={isLoading}
                automation-id="confirm-discard-keep"
            >
                {keepEditingLabel}
            </Button>
            <Button
                onClick={onDiscard}
                color="error"
                variant="contained"
                disabled={isLoading}
                automation-id="confirm-discard-discard"
            >
                {discardLabel}
            </Button>
        </DialogActions>
    </Dialog>
);
